import React, {
  useCallback,
  useRef,
  useEffect,
  useState,
  useMemo,
} from 'react';

import { FiChevronDown, FiEye, FiXCircle, FiEyeOff } from 'react-icons/fi';

import {
  Badge,
  Box,
  Button,
  Divider,
  Flex,
  IconButton,
  Tag,
  HStack,
  Text,
  RadioGroup,
  Radio,
  useToast,
  Heading,
  Tooltip,
} from '@chakra-ui/react';

import { FormHandles } from '@unform/core/typings/types';

import { Form } from '@unform/web';

import { format, parseISO } from 'date-fns';

import * as Yup from 'yup';

import { Replace } from '~/helpers/Replace';

import { Department } from '~/modules/management/@types/management';

import {
  CardGraphicDepartment,
  DepartmentChart,
} from '~/shared/components/CardGraphicDepartment';

import RadioChakra from '~/shared/components/InputChakra/RadioChakra';
import SelectChakra from '~/shared/components/InputChakra/SelectChakra';
import LoadingAbsolute from '~/shared/components/LoadingAbsolute';
import { IPaginationProps } from '~/shared/components/Pagination';
import SectionHeader from '~/shared/components/SectionHeader';
import Table, { THeadProps } from '~/shared/components/Table';
import api from '~/shared/services/api';
import getOptionsDataLabel from '~/utils/getOptionsDataLabel';
import getValidationErrors from '~/utils/getValidationErrors';

import BadgeStatusInfo from '../../components/BadgeStatusInfo';
import { Card, ContainerCards } from './styles';

// objeto que representa o total de delay (atrasos) de um departamento
interface DepartmentTotalDelay extends DepartmentChart {
  total_delay: number;
  total_real_delay: number;
  total_open_activities: number;
  total_regular: number;
  total_real_regular: number;
}

// objeto que representa os departamento que esta atrasados
interface DepartmentDelay extends DepartmentTotalDelay {
  subordinate_departments?: DepartmentTotalDelay[];
}
// Criando um objeto que representa os atrasos do funcionario
interface EmployeeDelay {
  id: number;
  nome: string;
  departamento_id: number;
  label: string;
  value: string;
}
// objeto (componete) que representa o total de atividades
interface TotalAct extends IPaginationProps {
  total_delay: number;
  real_delay: number;
  departments: DepartmentDelay[];
  employees: EmployeeDelay[];
  // delay_planning: PlanningDelay;
  total_general: number;
  total_regular: number;
  real_regular: number;
}
// objeto que representa os planejamentos que estao em atraso
interface PlanningDelay extends IPaginationProps {
  data: Planning[];
}
// Objeto que representa a nossa tabela de planejamento/atendimento(atividades planejadas)
interface Planning {
  planning_id: number;
  attendance_id: number;
  demand_id: number;
  competence: string;
  description: string;
  created_at: string;
  demand: string;
  company: string;
  user: string;
  activity: string;
  duration: string;
  start_date_planned: string;
  fatal_date: string;
  status: string;
  color: string;
}
// objeto que representa a demanda
export interface Demand {
  nome: string;
  id: string;
}
// objeto que representa o status da quantidade de demanda
export interface QuantityStatusDemand {
  delayed: number;
  delayed_fatal_date: number;
  delay_forecast: number;
  running: number;
}
// objeto que representa as demandas bem como o status da quantidade de demanda, basicamente e as nossas demandas
export interface Demands {
  demands: Demand[];
  total: QuantityStatusDemand;
}
// objeto que representa as opcoes de demanda
export interface OptionDemand {
  label: string;
  value: string | number;
}
// objeto que representa um Props de Departamentos... Lembrando que Props sao: variaveis read only ao qual sao passadas do componente pais ao filho.  Sao dados passados dinamicamente ao filho
export interface DepartmentProps {
  data: Department[];
  labels: string[];
  dataLabels: number[];
  value: number[];
}
// objeto que representa a demanda e a data que essa demanda foi criada bem como a sua competencia
export interface DemandData {
  id: number;
  competencia?: string;
  descricao?: string;
  nome_empresa: string;
  nome_demanda: string;
  demanda_id: number;
  created_at: string;
}
interface AllDepartment {
  id: number;
  name: string;
  isManage: boolean;
  value: number;
  label: string;
}
interface AllDepartmentDelay extends AllDepartment {
  real_delay: boolean;
}

interface SelectedDepartmentDelay {
  id: number;
  employee_id?: number;
  isManage: boolean;
  real_delay: boolean;
}

// crinado componente de Analise de Atividades --- INICIO DO NOSSO COMPONENTE!

const AnalyzeActivities: React.FC = () => {
  
  const formRef = useRef<FormHandles>(null);
  const addToast = useToast();

  const [loaded, setLoaded] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loadingCleanFilter, setLoadingCleanFilter] = useState(false);
  const [loadingDelayPlannings, setLoadingDelayPlannings] = useState(false);
  const [hideEye, setHideEye] = useState(false);

  // criando um estado do objeto total de atividades vazio, estamos fazendo uma desestruturacao do array retornado pelo hook useState, lembre-se disso
  const [totalActivities, setTotalActivities] = useState<TotalAct>(
    {} as TotalAct,
  );

  const [delayPlannings, setDelayPlannings] = useState<PlanningDelay>();

  const [
    selectedDepartmentDelay,
    setSelectedDepartmentDelay,
  ] = useState<SelectedDepartmentDelay>();
  const [selectedDelay, setSelectedDelay] = useState('Atrasadas Gerais');

  // Coleciona as gerencias e equipes no mesmo nível
  const [allDepartments, setAllDepartments] = useState<AllDepartmentDelay[]>(
    [],
  );

  const [allEmployeesDelay, setAllEmployeesDelay] = useState<EmployeeDelay[]>(
    [],
  );

  const [selectEmployeesDelay, setSelectEmployeesDelay] = useState<
    EmployeeDelay[]
  >([]);

  // Carrega o cabeçalho da tabela, com a seguinte lista dde objetos contendo valores armazenado pelo hook use memo
  const tableTitles = useMemo((): THeadProps[] => {
    return [
      {
        title: 'Demanda',
      },
      {
        title: 'Empresa',
      },
      {
        title: 'Competência',
      },
      {
        title: 'Atividade',
      },
      {
        title: 'Executante',
      },
      {
        title: 'Status Atividade',
        align: 'center',
      },
      {
        title: 'Ações',
      },
    ];
  }, []);

  // Use memori aceita um segundo parametro para declarar depedencias, neste caso nao temos pois e uma lista vazia
  
  // damandChartLabels, define os dados que aparecem no nosso gráfico! 
  
  const demandChartLabels = useMemo(() => {

    // coloca no fincal dos arrays Entregues e completed
    return {
      labels: ['Atrasadas Gerais', 'De fato no Prazo', 'De Fato Atrasadas', 'Dentro do Prazo'],
      dataLabels: ['delayed', 'regular_real', 'delayed_real', 'regular'],
    };
  }, []);

  // ----------------------------------------------------- INICIO DA PROCURA OUTHER --------------------------------------------------------------------------------------------------

  const loadActivitiesDelay = useCallback(() => {
    
    setLoaded(true); // mostra o carregamento de componentes da página
    setTotalActivities({} as TotalAct);

    // atencao aos parametros envios na requisicao com axios 
    // o back-end vai retornar as listas contendo departamentos e empregados...

    api
      .get<TotalAct>('/analytic/activities/delay', {
        params: {
          list_departments: 1,
          list_employees: 1,
        },
      })
      .then((response) => {
        
        // Object Destructuring com Renomeação (Aliasing) -> Desestruturação de Objeto\Array com Renomeação

        // O uso das chaves { } do lado esquerdo do sinal de igual indica que você quer "extrair" propriedades específicas de dentro do objeto response.
        // A parte depois dos dois pontos (:) é o "pulo do gato". Você está dizendo ao TypeScript:
        // "Pegue a propriedade departments que vem da API, mas, dentro deste arquivo, eu quero que o nome da variável seja departmentsDelay."
        
        const {
          departments: departmentsDelay,
          employees: employeesDelay,
        } = response.data;

        // console.log(response);

        // console.log(response.data);
        
        const collectDepartments: AllDepartmentDelay[] = [];


        // ... é o que chamamos de spread ou espalhamento -> serve para: espalhar(copiar/expandir)
        // usamos para obter todos os dados quando é no lado direito
        // e no lado esquedo para pegar o restante dos dados
        
        // para objetos
        // ...response.data -> copia todas as propriedades do objeto response.data e coloca denttro do novo objeto... 
        // response.data... -> restante mesmo conceito... 

        // para array, podemos usar spread para expandir, depende como você quer manipular os dados, exemplo:
        // const numeros = [1, 2, 3]; const maisNumeros = [0, ...numeros, 4, 5]; console.log(maisNumeros)
        
        setTotalActivities({
          ...response.data,
          departments: departmentsDelay.map((dep) => {
            
            console.log(dep)

            // esra variável mapeia justamente: dataLabels: ['delayed', 'regular', 'delayed_real', 'other']
            const dataLabels = demandChartLabels.dataLabels.map(
              (lab) => `${lab}-${dep.id}`,
            );

            // console.log(dataLabels);

            collectDepartments.push({
              id: dep.id,
              name: dep.name,
              isManage: true,
              real_delay: false,
              label: dep.name,
              value: dep.id,
            });
            
            // AQUI ESTAMOS REALIZANDO O CALCULO DAS ATIVIDADES EM ATRASO POR DEPARTAMENTO!

            // estamos realizando o somatório da quantidade de atividades atradas pela quantidade de atividades regular
            const totalActivitiesSum = dep.total_delay + dep.total_regular
             
            // console.log(dep.total_real_regular);

            // const totalActivyRegular = dep.total_real_regular;
            
            // dep.total_open_activities -> retorna o total de atividades em aberto, basicamente a mesma coisa que o totalActivitiesSum

            // aqui estamos retornando a porcentagem das atividades atrasadas
            const delayPercent = (dep.total_delay * 100) /totalActivitiesSum;
            
            // somatorio de todas as atividades reais... das que realmente estao atrasadas com as que ainda estao em aberto dentro do prazo... (esta podem ser atradas pela suas antecessoras)
            
            // const totalRealActivitiesSum = dep.total_real_delay // para debugar
            
            const totalRealActivitiesSum = dep.total_real_delay + dep.total_real_regular;

            // Calcula a porcentagem das atividades que realmente estao atrasadas
            const delayRealPercent = (dep.total_real_delay * 100) / totalRealActivitiesSum;
            
            /* Essa é a plotagem do gráfico para os departamentos superiores! */ 
            return {
              ...dep,
              center_top_value: delayPercent,
              center_lower_value: delayRealPercent,
              dataChart: {
                datasets: [   
                  // primeiro anel -  vamos ter os gráficos que estao com atraso geral e que realmente estao atrasados
                  {
                    borderWidth: [5, 5],
                    datalabels: {
                      display: [false, false, false, false],
                    },
                    // borderColor: '#fed7d750',
                    data: [
                      dep.total_delay, // total de atividades atrasadas idenpedentemente se ela é uma atividade predecessora ou sucessora
                      null, // total de atividades que realmente estao no Prazo, predecessoras sem depedentes (sucessoras) e sucessoras sem predecessoras pedentes
                      null, // total de atividades que realmente estao atrasadas predecessoras sem depedentes e (sucessoras) sem predecessoras pedentes
                      dep.total_regular, // total de atividades que dentro estao no prazo, predecessoras sem depedentes!
                    ],
                    // weight: 0.7,
                  },
                  // Segundo anel -  Vamos colocar o total de atividades que estao no Prazo, Realmente no Prazo e por fim as Finalizadas 
                  {
                    borderWidth: [5, 5],
                    datalabels: {
                      display: [false, false, false, false],
                    },

                    // borderColor: '#fed7d750','
                    data: [
                      null,
                      dep.total_real_regular,
                      dep.total_real_delay,
                      dep.total_regular,
                    ],
                    // weight: 1,
                  },
                ],
                labels: demandChartLabels.labels,
                dataLabels,

                // Essa linha de código é um "interruptor" de visibilidade para a Legenda do gráfico.
                // No mundo da programação (especialmente no CSS e em bibliotecas de componentes), a palavra display quase sempre se refere a 
                // "como ou se algo deve ser mostrado na tela".

                options: { legend: { display: false } },
                
              },
              subordinate_departments: dep.subordinate_departments?.map(
                (depSub) => {
                  const dataLabelsSub = demandChartLabels.dataLabels.map(
                    (lab) => `${lab}-${depSub.id}`,
                  );

                  collectDepartments.push({
                    id: depSub.id,
                    name: depSub.name,
                    isManage: false,
                    real_delay: false,
                    label: depSub.name,
                    value: depSub.id,
                  });

                  const totalActivitiesSumSub =
                    depSub.total_delay + depSub.total_regular;
                  const delayPercentSub =
                    (depSub.total_delay * 100) / totalActivitiesSumSub;

                  const totalRealActivitiesSumSub =
                    depSub.total_real_delay + depSub.total_real_regular;
                  const delayRealPercentSub =
                    (depSub.total_real_delay * 100) / totalRealActivitiesSumSub;


                    /* Esse é a plotagem do gráfico para os departamentos subordinados! */
                  return {
                    ...depSub,
                    center_top_value: delayPercentSub,
                    center_lower_value: delayRealPercentSub,
                      
                    // dataChart é o objeto pai. 
                    // Ele contém toda a inteligência visual do gráfico: 
                    // quais são os números, quais são os nomes e como eles devem se comportar.
                    
                    dataChart: {
                        
                      // datasets -> Este é um Array de Objetos. Cada objeto dentro dele representa uma "coleção" de dados. 
                      // No seu caso: Você tem dois objetos no array. Isso significa que o seu gráfico tem duas camadas 
                      // (dois anéis, se for um gráfico de rosca).
                        
                      datasets: [
                        {
                          
                          // boderWidth
                          // [5, 5]: Note que ele recebe um array. Isso significa: 
                          // "Coloque 5 pixels de borda na primeira fatia e 5 pixels na segunda". 
                          // Se você tivesse 4 valores no data, poderia usar [5, 5, 5, 5].

                          borderWidth: [5, 5],
                          
                          // datalabels
                          // Este é um plugin (geralmente o chartjs-plugin-datalabels) que serve para escrever o valor (ex: "10") 
                          // em cima da fatia do gráfico.
                          // Como você colocou false, entao você esta dizendo:
                          // "Não mostre o texto escrito em cima de nenhuma das 4 fatias possíveis".

                          datalabels: {
                            display: [false, false, false, false],
                          },
                          
                          // borderColor: ['transparent', 'transparent'],
                          
                          
                          // data é o coração do dataset. é um array de números
                          // O que faz: Dá nome aos eixos ou às fatias.
                          // No seu código, vem do demandChartLabels.labels, que são: ['Atrasadas Gerais', 'No Prazo', 'Atrasadas Reais', 'Outras'].
                          // Regra de Ouro: O número de itens em labels deve ser igual ao número de itens no array data.

                          data: [
                            depSub.total_delay, // total de atividades atrasadas idenpedentemente se ela é uma atividade predecessora ou sucessora
                            null, // total de atividades que realmente estao no Prazo, predecessoras sem depedentes (sucessoras) e sucessoras sem predecessoras pedentes
                            null, // total de atividades que realmente estao atrasadas predecessoras sem depedentes e (sucessoras) sem predecessoras pedentes
                            depSub.total_regular, // total de atividades que dentro estao no prazo, predecessoras sem depedentes!
                          ],

                          align: 'end',
                          // weight: 0.7,
                        },
                        {
                          borderWidth: [5, 5],
                          datalabels: {
                            display: [false, false, false, false],
                          },
                          // borderWidth: 5,
                          // borderColor: ['transparent', 'transparent'],
                          data: [
                            null,
                            depSub.total_real_regular,
                            depSub.total_real_delay,
                            depSub.total_regular,
                          ],
                          align: 'end',
                          // weight: 1,
                        },
                      ],
                      
                      // Fica fora dos datasets, mas dentro do dataChart.
                      //  O que faz: Dá nome aos eixos ou às fatias.
                      // No seu código, vem do demandChartLabels.labels, que são: ['Atrasadas Gerais', 'No Prazo', 'Atrasadas Reais', 'Outras'].
                      // Regra de Ouro: O número de itens em labels deve ser igual ao número de itens no array data.

                      labels: demandChartLabels.labels,
                      
                      //  os datasLabels sao 
                      dataLabels: dataLabelsSub,
                      
                      // 
                      options: { legend: { display: false } },
                    },
                  };
                },
              ),
            };
          }),
        });

        setAllDepartments(collectDepartments.filter((dep) => dep.id !== 1));
        
        const employeeDelaySelect = employeesDelay.map((emp) => ({
          id: emp.id,
          nome: emp.nome,
          departamento_id: emp.departamento_id,
          label: emp.nome,
          value: emp.id.toString(),
        }));

        setAllEmployeesDelay(employeeDelaySelect);

        setSelectEmployeesDelay(employeeDelaySelect);

        // setTotalActivities();
      })
      .finally(() => setLoaded(true));
  }, [demandChartLabels]);

  // ----------------------------------------------------- FIM PROCURA OUTHER --------------------------------------------------------------------------------------------------
  
  const listDelayPlanningsDepartment = useCallback(
    async (
      numPage: number,
      realDelay: boolean,
      departmentId?: number,
      isManage?: boolean,
      employeeId?: number,
    ) => {
      setLoadingDelayPlannings(true);

      const routeBaseDelay = 'analytic/activities/delay/plannings';
      let data: PlanningDelay;

      try {
        const real = Number(realDelay);
        const manage = isManage ? Number(isManage) : 0;

        if (departmentId) {
          const { data: dados } = await api.get<PlanningDelay>(
            `${routeBaseDelay}/department/${departmentId}`,
            {
              params: {
                page: numPage,
                real,
                manage,
                employee_id: employeeId || null,
              },
            },
          );

          data = dados;
        } else {
          const { data: dados } = await api.get<PlanningDelay>(routeBaseDelay, {
            params: {
              page: numPage,
              real,
              manage,
              employee_id: employeeId || null,
            },
          });

          data = dados;
        }

        data.data = data.data.map((dd) => {
          return {
            ...dd,
            created_at: format(parseISO(dd.created_at), 'dd/MM/yyyy'),
          };
        });

        if (numPage === 1) {
          setDelayPlannings(data);
        } else {
          setDelayPlannings((state) => ({
            ...data,
            // Sobrescrevemos tudo de paginação, mas em data, mantemos o que tinha no estado e adicionamos os novos resultados
            data: [...(state?.data || []), ...data.data],
          }));
        }
      } finally {
        setLoadingDelayPlannings(false);
      }
    },
    [],
  );

  useEffect(() => {
    loadActivitiesDelay();
    listDelayPlanningsDepartment(1, false);
  }, [loadActivitiesDelay, listDelayPlanningsDepartment]);

  const handleSelectDepartment = useCallback(
    (departmentId: string) => {
      // console.log(departmentId);

      if (!departmentId) {
        setSelectEmployeesDelay(allEmployeesDelay);
        return;
      }

      setSelectEmployeesDelay(
        allEmployeesDelay.filter(
          (emp) => emp.departamento_id === Number(departmentId),
        ),
      );
    },
    [allEmployeesDelay],
  );

  const handleSelectDemand = useCallback(
    (value: string | number): void => {
      // console.log(value);
      const valueString = value.toString();
      const nameDelay = valueString.slice(0, valueString.indexOf('-'));

      if (nameDelay !== 'delayed' && nameDelay !== 'delayed_real') return;

      const delay = nameDelay === 'delayed_real';

      const depId = Number(valueString.substring(valueString.indexOf('-') + 1));

      formRef.current?.setData({
        delay: String(Number(delay)),
        department: depId,
      });

      const foundDepartment = allDepartments.find((dp) => dp.id === depId);

      setSelectedDepartmentDelay({
        id: depId,
        real_delay: delay,
        isManage: !!foundDepartment?.isManage,
      });

      // Ao filtrar a consulta através do gráfico listamos todos os funcionários novamente
      handleSelectDepartment(depId.toString());

      formRef.current?.clearField('employee_id');

      listDelayPlanningsDepartment(
        1,
        delay,
        foundDepartment?.id,
        foundDepartment?.isManage,
      );
    },
    [allDepartments, listDelayPlanningsDepartment, handleSelectDepartment],
  );

  const handleCleanFilter = useCallback(async () => {
    setLoadingCleanFilter(true);
    setLoadingDelayPlannings(true);
    try {
      formRef.current?.reset();
      // console.log(formRef.current?.getData());

      setSelectedDepartmentDelay(undefined);
      setSelectEmployeesDelay(allEmployeesDelay);
      await listDelayPlanningsDepartment(1, false);

      // formRef.current?.reset();
    } catch (err) {
      if (err.response?.status < 500) {
        addToast({
          position: 'top-right',
          status: 'error',
          title: 'Ooops!!!',
          description:
            err.response.data?.error || 'Ocorreu um erro, tente novamente.',
          isClosable: true,
        });

        return;
      }

      addToast({
        position: 'top-right',
        status: 'error',
        title: 'Ooops! Ocorreu um erro no servidor.',
        isClosable: true,
      });
    }
    setLoadingCleanFilter(false);
    setLoadingDelayPlannings(false);
  }, [addToast, listDelayPlanningsDepartment, allEmployeesDelay]);

  const handleSubmit = useCallback(
    async (data: any) => {
      // formRef.current?.reset();
      // console.log(formRef.current?.getData());
      try {
        setLoadingSubmit(true);
        setLoadingDelayPlannings(true);
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          delay: Yup.string().required('Necessário escolher uma opção'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const isManage = !!allDepartments.find(
          (dep) => dep.id === Number(data?.department),
        )?.isManage;

        setSelectedDepartmentDelay({
          id: data?.department,
          isManage,
          real_delay: data.delay === '1',
          employee_id: data?.employee_id,
        });

        await listDelayPlanningsDepartment(
          1,
          data.delay,
          data?.department,
          isManage,
          data?.employee_id,
        );

        // formRef.current?.reset();
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
          return;
        }

        if (err.response?.status < 500) {
          addToast({
            position: 'top-right',
            status: 'error',
            title: 'Ooops!!!',
            description:
              err.response.data?.error || 'Ocorreu um erro, tente novamente.',
            isClosable: true,
          });

          return;
        }

        addToast({
          position: 'top-right',
          status: 'error',
          title: 'Ooops! Ocorreu um erro no servidor.',
          isClosable: true,
        });
      }
      setLoadingSubmit(false);
      setLoadingDelayPlannings(false);
    },
    [addToast, listDelayPlanningsDepartment, allDepartments],
  );


  // RETORNANDO O COMPONENTE REACT! 
  
  return (
    
    <Box position="relative">
      {!loaded && <LoadingAbsolute z_index={1111} min_height={500} />}
      <Flex justifyContent="space-between" flexDir={['column', 'row']}>
        <SectionHeader
          title="Gráfico de Atrasos"
          pagename="Visualize o percentual de atrasos por departamento em relação a quantidade total de atividades"
          goBackLink="/"
          goBackPage
        />
        <Button
          leftIcon={!hideEye ? <FiEye size="20px" /> : <FiEyeOff size="20px" />}
          aria-label="ocultar gráficos"
          onClick={() => setHideEye(!hideEye)}
          mb={[3, 0]}
          shadow="md"
        >
          Ocultar
        </Button>
      </Flex>

      {/* Aqui é o Card dos gráficos! */}

      {loaded && !hideEye && (
        <Flex justifyContent="center">
          <ContainerCards>
            {totalActivities &&
              !!totalActivities.departments?.length &&
              totalActivities.departments.map((dep) => {
                return dep.total_delay === 0 ? (
                  ''
                ) : (
                  <Card key={dep.id} mb={[5, 0]}>
                    <Box w="full" boxShadow="md">
                      {/* Aqui esta o componente de grafico para departamentos! */}
                      <CardGraphicDepartment
                        avatar={dep.responsible?.avatar}
                        name={dep.responsible?.name}
                        department={dep}
                        enablePluginDataLabel
                        theme="delay"
                        selectChart={(value) => handleSelectDemand(value)}
                      />
                    </Box>
                  </Card>
                );
              })}
          </ContainerCards>
        </Flex>
      )}

      {/* Esse componente é basicamente */}
      <Divider w="full" my={5} />

      {/* Apartir daqui para baixo é a tabela/drilldown ccom seus filtros e execuções com rolagem infinita! */}
      
      {delayPlannings && (
        <>
          <Form
            onSubmit={handleSubmit}
            ref={formRef}
            initialData={{ delay: '0' }}
          >
            <Flex
              flexDir={{ base: 'column', lg: 'row' }}
              alignItems={{ base: 'start', lg: 'center' }}
              // justifyContent="space-between"
            >
              {/* {!!selectedDelay &&
                {
                  <Tag colorScheme="red" mb={2}>
                    <Badge variant="subtle" mr={2} bg="red.200" color="white">
                      Status:
                    </Badge>

                    <Text fontWeight={600}>{selectedDelay}</Text>
                  </Tag>
                }} */}

              <Flex flexDir="column" mr={4} minWidth="">
                <Heading
                  as="h5"
                  size="sm"
                  mb={1}
                  fontWeight={500}
                  cursor="default"
                  color="gray.500"
                  marginBottom={4}
                >
                  Atrasos
                </Heading>
                <RadioChakra
                  flexDir={['column', 'row']}
                  name="delay"
                  justifyContent="space-between"
                  options={[
                    {
                      label: 'Atrasadas Gerais',
                      value: '0',
                      colorScheme: 'red',
                    },
                    {
                      label: 'De Fato Atrasadas',
                      value: '1',
                      colorScheme: 'red',
                    },
                  ]}
                  wrapOption="nowrap"
                />
              </Flex>
              <Flex
                width="full"
                flexDir={{ base: 'column', lg: 'row' }}
                alignItems="center"
              >
                <Box ml={{ base: 0, lg: 8 }} width="full">
                  <SelectChakra
                    options={allDepartments}
                    name="department"
                    label="Departamentos"
                    placeholder="Todos"
                    onChange={(el) =>
                      handleSelectDepartment(el.currentTarget.value)
                    }
                    width="full"
                    // minWidth="315px"
                  />
                </Box>
                <Box mx={{ base: 0, lg: 4 }} width="full">
                  <SelectChakra
                    options={selectEmployeesDelay}
                    name="employee_id"
                    label="Funcionários"
                    placeholder="Todos"
                    width="full"
                  />
                </Box>
              </Flex>
              <Flex
                // justifyContent="center"
                alignItems="center"
                flexDir={{ base: 'column', lg: 'row' }}
                width={{ base: 'full', lg: 'auto' }}
                mt={{ base: 3, lg: 0 }}
                mb={{ base: 3, lg: 0 }}
              >
                <Box width="full" minWidth="200px" mr={{ base: 0, lg: 3 }}>
                  <Button
                    onClick={() => formRef.current?.submitForm()}
                    colorScheme="green"
                    width="full"
                    // maxWidth={['full', '200px']}
                    isLoading={loadingSubmit}
                    isDisabled={loadingCleanFilter}
                  >
                    Filtrar
                  </Button>
                </Box>
                <Box mt={{ base: 3, lg: 0 }} width="full" minWidth="200px">
                  <Button
                    onClick={() => handleCleanFilter()}
                    colorScheme="gray"
                    width="full"
                    // maxWidth={['full', '200px']}
                    isLoading={loadingCleanFilter}
                    isDisabled={loadingSubmit}
                  >
                    Limpar Filtro
                  </Button>
                </Box>
              </Flex>
            </Flex>
          </Form>

          <Divider w="full" />
          <Table
            loading={loadingDelayPlannings}
            isLoadingScroll
            theadData={tableTitles}
          >
            {!!delayPlannings.data.length &&
              delayPlannings.data.map((plan) => (
                <Box
                  p={2}
                  as="tr"
                  key={plan.planning_id}
                  _hover={{ bg: 'gray.50' }}
                >
                  <Tooltip
                    aria-label={plan.demand}
                    label={plan.demand}
                    zIndex={1}
                  >
                    <Text isTruncated maxW={250} p={2} as="td">
                      {plan.demand}
                    </Text>
                  </Tooltip>
                  <Box p={2} as="td">
                    <Tooltip
                      aria-label={plan.company}
                      label={plan.company}
                      zIndex={1}
                    >
                      <Text isTruncated maxW={250}>
                        {plan.company}
                      </Text>
                    </Tooltip>
                  </Box>
                  <Box p={2} as="td">
                    {plan.competence && <Tag>{plan.competence}</Tag>}
                  </Box>
                  <Tooltip
                    aria-label={plan.activity}
                    label={plan.activity}
                    zIndex={1}
                  >
                    <Text isTruncated maxW={150} p={2} as="td">
                      {plan.activity}
                    </Text>
                  </Tooltip>
                  <Tooltip aria-label={plan.user} label={plan.user} zIndex={1}>
                    <Text isTruncated maxW={150} p={2} as="td">
                      {plan.user}
                    </Text>
                  </Tooltip>

                  <Box p={2} as="td" textAlign="center">
                    <BadgeStatusInfo
                      status={plan.status}
                      statusColor={plan.color}
                    />
                  </Box>
                  <Box p={2} as="td" className="row" textAlign="end">
                    <HStack spacing={2} justify="center">
                      <a
                        href={`${process.env.REACT_APP_OLDMYIPAC}/planejamento/index/${plan.demand_id}?aten=${plan.attendance_id}&pg=1`}
                        target="__blank"
                      >
                        <IconButton
                          aria-label="Ver planejamento"
                          icon={<FiEye />}
                          variant="ghost"
                          bg="gray.100"
                          ml={{ base: 0, lg: 2 }}
                          colorScheme="gray"
                        />
                      </a>
                    </HStack>
                  </Box>
                </Box>
              ))}
          </Table>
          {!loadingSubmit &&
            !loadingCleanFilter &&
            delayPlannings.current_page < delayPlannings.last_page && (
              <Flex justifyContent="center" mt={3}>
                <Button
                  colorScheme="teal"
                  variant="ghost"
                  isDisabled={
                    loadingSubmit || loadingCleanFilter || loadingDelayPlannings
                  }
                  rightIcon={<FiChevronDown />}
                  onClick={() =>
                    listDelayPlanningsDepartment(
                      delayPlannings.current_page + 1,
                      !!selectedDepartmentDelay?.real_delay,
                      selectedDepartmentDelay?.id,
                      selectedDepartmentDelay?.isManage,
                      selectedDepartmentDelay?.employee_id,
                    )
                  }
                >
                  Carregar mais
                </Button>
              </Flex>
            )}
        </>
      )}
    </Box>
  );
};

export default AnalyzeActivities;
